<template>
    <div class="m-control__control a-control a-dateRange">
        <date-range-picker
            ref="picker"
            :show-dropdowns="true"
            :auto-apply="true"
            :ranges="false"
            :locale-data="localeData"
            v-model="dateRange"
            :append-to-body="true"
            control-container-class="a-control__input a-control__input--gray a-dateRange__control"
        >
            <template
                v-if="dateRange"
                v-slot:input="picker"
            >
                {{ $dayjs(picker.startDate).format('DD.MM.YYYY') }} - {{ $dayjs(picker.endDate).format('DD.MM.YYYY') }}
            </template>
        </date-range-picker>
    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    components: {
        DateRangePicker
    },
    props: {
        value: {
            type: Object,
            requred: true
        }
    },
    computed: {
        dateRange: {
            get() {
                return this.value
            },
            set(dateRange) {
                this.$emit('input', {
                    startDate: this.$dayjs(dateRange.startDate).format('YYYY-MM-DD'),
                    endDate: this.$dayjs(dateRange.endDate).format('YYYY-MM-DD')
                })
            }
        },
        localeData() {
            return {
                firstDay: 1,
                format: 'YYYY-MM-DD',
                daysOfWeek: ['Nd', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
                monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień']
            }
        }
    }
}
</script>
